import { render, staticRenderFns } from "./SubcategoryItem.vue?vue&type=template&id=159c8ebc&scoped=true"
import script from "./SubcategoryItem.vue?vue&type=script&lang=js"
export * from "./SubcategoryItem.vue?vue&type=script&lang=js"
import style0 from "./SubcategoryItem.vue?vue&type=style&index=0&id=159c8ebc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c8ebc",
  null
  
)

export default component.exports